import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    Stack,
    Divider,
    Grid,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ReceiptIcon from "@mui/icons-material/Receipt";

export default function CustomerDetailDialog({
    open,
    onClose,
    customer,
    orders,
    onViewInvoice,
    onLoadMore,
    hasMore,
}) {
    console.log("orders", orders);
    return (
        <Dialog open={open} fullScreen onClose={onClose}>
            <DialogTitle>Chi tiết khách hàng</DialogTitle>
            <DialogContent>
                {customer && (
                    <Box sx={{ p: 2 }}>
                        <Stack spacing={1}>
                            <Typography variant="h6" fontWeight="bold">
                                {customer.name}
                            </Typography>

                            <Grid container spacing={1} alignItems="center">
                                <Grid item>
                                    <EmailIcon fontSize="small" />
                                </Grid>
                                <Grid item>
                                    <Typography fontSize="14px">
                                        Email: {customer.email || "Chưa có"}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1} alignItems="center">
                                <Grid item>
                                    <PhoneIcon fontSize="small" />
                                </Grid>
                                <Grid item>
                                    <Typography fontSize="14px">
                                        SĐT: {customer.phone || "Chưa có"}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1} alignItems="center">
                                <Grid item>
                                    <LocationOnIcon fontSize="small" />
                                </Grid>
                                <Grid item>
                                    <Typography fontSize="14px">
                                        Địa chỉ:{" "}
                                        {`${customer?.address?.street || ""}, ${
                                            customer?.address?.city || ""
                                        }, ${customer?.address?.state || ""}, ${
                                            customer?.address?.country || ""
                                        }`.replace(
                                            /^, |, , |, , ,/g,
                                            "Chưa có"
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1} alignItems="center">
                                <Grid item>
                                    <MonetizationOnIcon fontSize="small" />
                                </Grid>
                                <Grid item>
                                    <Typography fontSize="14px" color="error">
                                        Công nợ:{" "}
                                        {customer.debt?.toLocaleString("vi-VN")}{" "}
                                        ₫
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Stack>
                    </Box>
                )}

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Danh sách đơn hàng
                </Typography>

                <Stack spacing={2}>
                    {orders.map((order) => (
                        <Card key={order._id} variant="outlined">
                            <CardContent>
                                <Stack spacing={1}>
                                    <Grid
                                        container
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Grid item>
                                            <ReceiptIcon fontSize="small" />
                                        </Grid>
                                        <Grid item>
                                            <Typography fontWeight="bold">
                                                Mã đơn hàng: {order.orderCode}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    {order.items.map((item) => (
                                        <Typography fontSize="14px">
                                        {item.name} - {"SL: "}{item.quantity}
                                    </Typography>
                                    ))}
                                    <Typography fontSize="14px">
                                        Tổng tiền:{" "}
                                        {order.totalAmount.toLocaleString(
                                            "vi-VN"
                                        )}{" "}
                                        ₫
                                    </Typography>
                                    <Typography fontSize="14px">
                                        Đã thanh toán:{" "}
                                        {order.amountPaid.toLocaleString(
                                            "vi-VN"
                                        )}{" "}
                                        ₫
                                    </Typography>
                                    <Typography fontSize="14px">
                                        Ngày tạo:{" "}
                                        {new Date(
                                            order.createdAt
                                        ).toLocaleDateString("vi-VN")}
                                    </Typography>

                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => onViewInvoice(order)}
                                        sx={{ mt: 1, alignSelf: "start" }}
                                    >
                                        Xem hóa đơn
                                    </Button>
                                </Stack>
                            </CardContent>
                        </Card>
                    ))}
                </Stack>
                {hasMore && (
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Button onClick={onLoadMore}>Tải thêm hóa đơn</Button>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Đóng</Button>
            </DialogActions>
        </Dialog>
    );
}